import { B2bGenerateBox } from 'src/components/biz-b2b-generate-box';

export default B2bGenerateBox;
